export default __webpack_public_path__ + "static/media/Yurt2.e8709986.jpg";